import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'view-running-comparison-report',
  templateUrl: 'view-running-comparison-report.component.html',
})
export class ViewRunningComparisonReportComponent implements OnInit {
  initialized = false;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.initialized = true;
  }
}
